import React from "react";
import { Trophy, Crown, Medal } from "@phosphor-icons/react";

const TIER_STYLES = {
  Premier: {
    border: "border-[#D4AF37]/60",
    bg: "bg-gradient-to-br from-[#D4AF37]/20 to-[#D4AF37]/5",
    text: "text-[#D4AF37]",
    icon: Crown,
    shadow: "shadow-[0_0_30px_rgba(212,175,55,0.2)]",
  },
  Growth: {
    border: "border-purple-400/40",
    bg: "bg-gradient-to-br from-purple-500/15 to-purple-500/5",
    text: "text-purple-200",
    icon: Trophy,
    shadow: "shadow-[0_0_20px_rgba(168,85,247,0.15)]",
  },
  Standard: {
    border: "border-white/15",
    bg: "bg-white/5",
    text: "text-white/80",
    icon: Medal,
    shadow: "",
  },
};

export function TierBadge({ tier, size = "md" }) {
  if (!tier) return null;
  const style = TIER_STYLES[tier.name] || TIER_STYLES.Standard;
  const Icon = style.icon;
  const sizes = {
    sm: "text-[10px] px-2 py-0.5 gap-1",
    md: "text-xs px-2.5 py-1 gap-1.5",
    lg: "text-sm px-3 py-1.5 gap-2",
  };
  const iconSizes = { sm: 10, md: 13, lg: 16 };
  return (
    <span
      className={`inline-flex items-center uppercase tracking-widest font-sans rounded-full border ${style.border} ${style.bg} ${style.text} ${sizes[size]}`}
      data-testid={`tier-badge-${tier.name}`}
    >
      <Icon size={iconSizes[size]} weight="duotone" />
      {tier.name} · {tier.rate}%
    </span>
  );
}
